import React, { useCallback } from 'react';

import { Platform, Pressable } from 'react-native';

import { PROFILE_AVATAR } from 'config/testID';

import ProfileLogo from '../ProfileLogo';
import styles from './styles';

type Props = {
    iconId: string;
    index: number;
    onPress: (iconId: string) => void;
};

function ProfileAvatar({ iconId, index, onPress }: Props) {
    const handlePress = useCallback(() => {
        onPress(iconId);
    }, [iconId, onPress]);

    return (
        <Pressable
            style={({ pressed }) => [
                styles.container,
                {
                    opacity: pressed ? 0.5 : 1,
                },
            ]}
            onPress={handlePress}
            testID={`${PROFILE_AVATAR}_${index}`}
            accessibilityLabel={iconId}
            accessibilityRole={Platform.select({
                web: 'imagebutton',
                default: 'button',
            })}
            accessible
        >
            <ProfileLogo iconId={iconId} withPlaceholder />
        </Pressable>
    );
}

export default ProfileAvatar;
